import React from 'react';
import PropTypes from 'prop-types';
import { convertToJalali } from '../utils';

export default function ToggledRow(props) {
  let { rowValues, items = {} } = props;

  return (
    <div>
      {Object.keys(items).map(item => (
        <div>
          <span>{items[item]}:</span>{' '}
          {Boolean(rowValues[item])
            ? item.includes('date')
              ? convertToJalali(rowValues[item])
              : rowValues[item]
            : '-'}
        </div>
      ))}
    </div>
  );
}

ToggledRow.propTypes = {
  rowValues: PropTypes.object.isRequired,
  items: PropTypes.object,
};
